export const Types = {
    SAVE_LIST_MONEY_TRANSACTION: 'SAVE_LIST_MONEY_TRANSACTION',
    SAVE_LIST_WITHDRAW_MONEY_TRANSACTION: 'SAVE_LIST_WITHDRAW_MONEY_TRANSACTION',
    SAVE_LIST_GOLD_TRANSACTION: 'SAVE_LIST_GOLD_TRANSACTION',
    SAVE_LIST_BANK_TRANSACTION: 'SAVE_LIST_BANK_TRANSACTION',
    SAVE_LIST_MODAL_GOLD_TRANSACTION: 'SAVE_LIST_MODAL_GOLD_TRANSACTION',
    SAVE_LIST_BANK_CONFIG: 'SAVE_LIST_BANK_CONFIG',
    SAVE_ALL_BANK: 'SAVE_ALL_BANK',
    SAVE_LIST_TRANSACTION_BUY_SELL_GOLD: 'SAVE_LIST_TRANSACTION_BUY_SELL_GOLD',
    SAVE_LIST_COMMISSIONS_AGENTS: 'SAVE_LIST_COMMISSIONS_AGENTS',
    SAVE_LIST_TRANFER_GOLD: 'SAVE_LIST_TRANFER_GOLD',
    SAVE_LIST_SEND_GOLD: 'SAVE_LIST_SEND_GOLD',
    SAVE_LIST_SWAP_HNG: 'SAVE_LIST_SWAP_HNG',
    SAVE_LIST_SWAP_HNG_TELE : 'SAVE_LIST_SWAP_HNG_TELE',
    SAVE_LIST_BUY_XAU_TELE : 'SAVE_LIST_BUY_XAU_TELE',
    SAVE_LIST_SELL_XAU_TELE : 'SAVE_LIST_SELL_XAU_TELE',
    SAVE_LIST_STAKING_DAILY: 'SAVE_LIST_STAKING_DAILY',
    SAVE_LIST_REQUEST_CLAIM: 'SAVE_LIST_REQUEST_CLAIM',
    SAVE_LIST_SWAP_USD: 'SAVE_LIST_SWAP_USD',
    SAVE_LIST_SWAP_XAU: 'SAVE_LIST_SWAP_XAU',
    SAVE_LIST_SWAP_TON: 'SAVE_LIST_SWAP_TON',
    SAVE_LIST_WITHDRAW_USDT : 'SAVE_LIST_WITHDRAW_USDT',
    SAVE_LIST_DEPOSIT_USDT : 'SAVE_LIST_DEPOSIT_USDT'
}
